module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#cinema",
      toString: function () {
        return this.url;
      }
    }